import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { VH_USER_ACCESS } from '../types/vhUserAccess.js';
export const vhUserAccessDescriptor = {
    name: VH_USER_ACCESS,
    label: 'VH User Access',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_user_access',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Per-user VH module liberation. Written by SysColect org-user-manager (req 0006). VH reads only.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: '== doc id == uid; satisfies repository {id} contract.',
        },
        {
            name: 'uid',
            label: 'User UID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: 'SysColect/Firebase user uid (=== id).',
        },
        {
            name: 'modules',
            label: 'Modules',
            type: 'array',
            required: true,
            arrayItemType: 'string',
            description: 'Liberated VH module slugs (subset of org allowedModules). Each slug max 80 chars.',
        },
        {
            name: 'updatedAt',
            label: 'Updated At',
            type: 'string',
            required: true,
            maxLength: 32,
        },
        {
            name: 'updatedBy',
            label: 'Updated By',
            type: 'string',
            required: true,
            maxLength: 128,
        },
    ],
};
//# sourceMappingURL=vhUserAccess.descriptor.js.map